
const baseUrl = process.env.REACT_APP_PAGE_BASE_URL
const legacyUrl = process.env.REACT_APP_PAGE_LEGACY_URL
export {
    baseUrl,
    legacyUrl
}